export const EXTENSION ="https://chrome.google.com/webstore/detail/uso-ukrainian-support-org/pceehdadbjnngdkflkgalipflomjhmei"